import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { createUseStyles } from 'hoi-poi-ui';
import classNames from 'classnames';
import styles from "./styles.js";
const useStyles = createUseStyles(styles, 'Layout');
const Layout = _ref => {
  let {
    children,
    className,
    overrides
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.root, className)
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: classes.children
  }, overrides === null || overrides === void 0 ? void 0 : overrides.children), children));
};
export default /*#__PURE__*/memo(Layout);